import { jsx as _jsx } from "react/jsx-runtime";
import Script from "next/script";
export var JsonLDType;
(function(JsonLDType) {
    JsonLDType["BreadcrumbList"] = "BreadcrumbList";
    JsonLDType["ListItem"] = "ListItem";
    JsonLDType["FaqPage"] = "FAQPage";
    JsonLDType["Question"] = "Question";
    JsonLDType["Answer"] = "Answer";
    JsonLDType["VideoObject"] = "VideoObject";
    JsonLDType["HowTo"] = "HowTo";
    JsonLDType["Review"] = "Review";
    JsonLDType["Vehicle"] = "Vehicle";
    JsonLDType["AutomotiveBusiness"] = "AutomotiveBusiness";
})(JsonLDType || (JsonLDType = {}));
export const JsonLdScript = ({ schema , tagId  })=>/*#__PURE__*/ _jsx(Script, {
        type: "application/ld+json",
        "data-testid": "json-ld-script",
        id: tagId,
        strategy: "beforeInteractive",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "https://schema.org",
                ...[
                    schema
                ]
            }, null, 2)
        }
    });
